export default __webpack_public_path__ + "static/media/vitiligo-frontp.0da31bb9.pdf";